import { useMemo } from "react";
export const defaultColor = '#595959';
export const defaultActiveColor = '#2d87f3';
export const SizeMap = {
    'normal': 24,
    'sm': 20,
    'xs': 18,
    'sxs': 16,
};
export const defaultSize = SizeMap.normal;
export const getSize = (size) => {
    if (typeof size === 'number')
        return size;
    return SizeMap[size] || size || defaultSize;
};
export const useGetSize = (size) => {
    return useMemo(() => getSize(size), [size]);
};
